import { useCallback, useEffect, useState } from "react";
import {
  INPUT_APPEARANCE_EVENT,
  INPUT_APPEARANCE_KEY,
  InputAppearance,
  readInputAppearance,
  writeInputAppearance,
} from "utils/inputAppearance";

/**
 * Reaktywny dostęp do preferencji wyglądu pól (Input). Aktualizuje się przy zmianie
 * w tej karcie (INPUT_APPEARANCE_EVENT), w innej karcie (storage) oraz po hydratacji
 * AppSettings z BE. Zwraca krotkę [view, setView].
 */
export const useInputAppearance = (): [
  InputAppearance,
  (v: InputAppearance) => void,
] => {
  const [view, setView] = useState<InputAppearance>(readInputAppearance);

  useEffect(() => {
    const refresh = () => setView(readInputAppearance());
    const onStorage = (e: StorageEvent) => {
      if (e.key === INPUT_APPEARANCE_KEY) refresh();
    };
    const onHydrated = (e: Event) => {
      const keys = (e as CustomEvent<{ keys?: string[] }>).detail?.keys;
      if (!keys || keys.includes(INPUT_APPEARANCE_KEY)) refresh();
    };
    window.addEventListener(INPUT_APPEARANCE_EVENT, refresh);
    window.addEventListener("storage", onStorage);
    window.addEventListener("app-settings-hydrated", onHydrated);
    return () => {
      window.removeEventListener(INPUT_APPEARANCE_EVENT, refresh);
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("app-settings-hydrated", onHydrated);
    };
  }, []);

  const update = useCallback((v: InputAppearance) => {
    writeInputAppearance(v);
    setView(v);
  }, []);

  return [view, update];
};
